class ToastNotification extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector('.toast--container');
    this.message = this.querySelector('.toast--message');
    this.closeTimeout = undefined;
  }

  connectedCallback() {
    // eslint-disable-next-line no-undef
    this.toastOpenSubscriber = subscribe(PUB_SUB_EVENTS.toastOpen, this.open);
    document.addEventListener('click', this.close);
  }

  disconnectedCallback() {
    this.toastOpenSubscriber?.();
    this.clearScheduledClose();
    document.removeEventListener('click', this.close);
  }

  open = (event) => {
    const { message, status, closeMs = 3000 } = event;
    this.role = 'status';
    this.ariaHidden = false;
    this.message.innerHTML = message;
    this.classList.add('open', status);
    this.clearScheduledClose();
    this.closeTimeout = setTimeout(this.close, closeMs);
  };

  close = () => {
    this.role = 'none';
    this.ariaHidden = true;
    this.classList.remove('open');
  };

  clearScheduledClose() {
    if (this.closeTimeout) {
      window.clearTimeout(this.closeTimeout);
    }
  }
}

customElements.define('toast-notification', ToastNotification);
